import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import ClientLogoArea from "./ClientLogo";
import SideNavigations from "./SideNavigations";
import BottomControls from "./BottomControls";
import Routes from "./routes";
import PopUps from "../pop-ups/routes";
import FinanceReadOnlyGuard from "../common/FinanceReadOnlyGuard";

const MOBILE_NAV_MAX = 1024;

function isMobileNav() {
  return typeof window !== "undefined" && window.innerWidth <= MOBILE_NAV_MAX;
}

const Body = (props) => {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => {
      if (!isMobileNav()) setMobileNavOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const toggleMobileNav = () => {
    if (isMobileNav()) setMobileNavOpen((open) => !open);
  };

  const handleNavMouseEnter = (e) => {
    if (!isMobileNav()) e.currentTarget.classList.add("open");
  };

  const handleNavMouseLeave = (e) => {
    if (!isMobileNav()) e.currentTarget.classList.remove("open");
  };

  const navClassName = [
    "main-area-navigation",
    mobileNavOpen ? "open mobile-open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="main-area">
      {mobileNavOpen ? (
        <button
          type="button"
          className="mobile-nav-backdrop"
          aria-label="بستن منو"
          onClick={() => setMobileNavOpen(false)}
        />
      ) : null}
      <div
        className={navClassName}
        onMouseEnter={handleNavMouseEnter}
        onMouseLeave={handleNavMouseLeave}
      >
        <ClientLogoArea onLogoClick={toggleMobileNav} />
        <SideNavigations {...props} />
        <BottomControls />
      </div>
      <div className="main-area-router">
        <FinanceReadOnlyGuard location={location}>
          <Routes />
        </FinanceReadOnlyGuard>
      </div>
      <div className="main-area-popups">
        <PopUps />
      </div>
    </div>
  );
};

export default Body;
